<template>
	<FormItem v-bind="validateInfo">
		<template #label>
			<Tooltip placement="topLeft" :overlayStyle="{ 'max-width': '500px' }" color="black">
				<template #title v-if="small">
					<div v-for="option in tooltipOptions" :key="option.value">
						<TypographyText code class="radio-group-with-tooltip-code">{{ option.label }}</TypographyText>
						<span class="pd-sm-x">{{ option.tooltip }}</span>
					</div>
				</template>
				<template #title v-else>
					<div v-for="option in tooltipOptions" :key="option.value" class="radio-group-with-tooltip">
						<TypographyTitle :level="4">{{ option.label }}</TypographyTitle>
						<TypographyParagraph>{{ option.tooltip }}</TypographyParagraph>
					</div>
				</template>
				<QuestionCircleOutlined /> {{ $t(prefix + '.label') }}
			</Tooltip>
		</template>
		<RadioGroup
			v-model:value="modelValueInner"
			:options="radioOptions"
			option-type="button"
		/>
	</FormItem>
</template>

<script>
import { computed, toRef } from 'vue';

import { useI18n } from 'vue-i18n';

import { FormItem, Tooltip, TypographyText, TypographyTitle, TypographyParagraph, RadioGroup } from 'ant-design-vue';
import { QuestionCircleOutlined } from '@ant-design/icons-vue';

export default {
	components: {
		FormItem, Tooltip, TypographyText, TypographyTitle, TypographyParagraph, RadioGroup,
		QuestionCircleOutlined,
	},
	emits: ['update:modelValue'],
	props: {
		modelValue: {
			type: String,
			required: true,
		},
		options: {
			// items with field `value`
			type: Array,
			required: true,
		},
		validateInfo: {
			type: Object,
			required: true,
		},
		prefix: {
			// под этим префиксом ищем msgs для разных частей компонента:
			// label - подпись у поля
			// options - варианты для радиокнопок
			// tooltips - подсказки для значений радиокнопок
			type: String,
			required: true,
		},
		small: {
			type: Boolean,
			default: false,
		},
	},
	setup(props, { emit }) {
		const { t, te } = useI18n();
		const modelValueRef = toRef(props, 'modelValue');
		const modelValueInner = computed({
			get() {
				return modelValueRef.value;
			},
			set(value) {
				emit('update:modelValue', value);
			},
		});
		const optionsRef = toRef(props, 'options');
		const prefixRef = toRef(props, 'prefix');
		const radioOptions = computed(() => optionsRef.value.map(option => {
			const key = prefixRef.value + '.tooltips.' + option.value;
			return {
				label: t(prefixRef.value + '.options.' + option.value),
				value: option.value,
				tooltip: te(key) ? t(key) : '',
			}
		}));
		const tooltipOptions = computed(() => radioOptions.value.filter(option => option.tooltip.length > 0));
		return {
			modelValueInner,
			radioOptions,
			tooltipOptions,
		}
	},
}
</script>

<style>
.radio-group-with-tooltip .ant-typography {
	color: white;
}
.radio-group-with-tooltip div.ant-typography {
	color: #ffffffcc;
}
.radio-group-with-tooltip h4.ant-typography,
.radio-group-with-tooltip .ant-typography h4 {
	margin-bottom: 0.2em;
}
.ant-typography.radio-group-with-tooltip-code code {
	color: black;
	background-color: #eee;
}
</style>
